;(async () => {
  if (window.location.pathname.includes('/iframe')) {
    await import('iframe')
  } else if (window.location.pathname.includes('/map')) {
    await import('map')
  } else {
    await import('front')
  }
})()
